export * from "./ResultCard";
export * from "./IResultCardProps";
